// extracted by mini-css-extract-plugin
export default {"tags":"selectedTags_tags__gduJQ","tags__box":"selectedTags_tags__box__gmYgw","tags__text":"selectedTags_tags__text__DxURp"};